export const FileExtensionFilter = (
  typeFilterList = {},
  selectedTypes = []
) => {
  const result = {};

  selectedTypes.forEach((type) => {
    const extensions = typeFilterList[type] || [];
    extensions.forEach((ext) => {
      result[ext] = true;
    });
  });

  return result;
};